import { Radio, RadioGroup, Stack } from '@chakra-ui/react'
import { useEffect } from 'react'
import { Controller, FieldValues, Path } from 'react-hook-form'

import { Inputs } from './models'

type PropertyType<T, K extends keyof T> = T[K]

interface MyProps<T extends FieldValues, K extends Path<T>>
  extends Inputs.InputData<T, K> {
  options: Array<{
    label: string
    value: PropertyType<T, K>
  }>
}

export default function <T extends FieldValues, K extends Path<T>>(
  props: MyProps<T, K>,
) {
  const {
    useForm: { control },
    useFormField,
    options,
  } = props

  return (
    <Controller
      control={control}
      name={useFormField}
      render={({ field: { onChange, value } }) => {
        useEffect(() => {
          if (value === undefined) onChange(options[0].value)
        }, [value])

        return (
          <RadioGroup onChange={onChange} value={value}>
            <Stack direction="row">
              {options.map((option) => (
                <Radio
                  key={`${option.value}-${option.label}`}
                  value={option.value}
                  bg="#eeeeee20"
                  border="1px solid"
                >
                  {option.label}
                </Radio>
              ))}
            </Stack>
          </RadioGroup>
        )
      }}
    />
  )
}
